if (!customElements.get('video-with-text-player')) {
  customElements.define('video-with-text-player', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video || this.dataset.autoplay !== 'true') return;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.userPaused = false;
      this.visible = false;
      this.onPause = () => {
        if (this.autoPausing) this.autoPausing = false;
        else this.userPaused = true;
      };
      this.onPlay = () => { this.userPaused = false; };
      this.update = () => {
        if (!this.visible || document.hidden || this.motion.matches) {
          if (!this.video.paused) {
            this.autoPausing = true;
            this.video.pause();
          }
        } else if (!this.userPaused && this.video.paused) {
          this.video.play()?.catch(() => {});
        }
      };
      this.video.addEventListener('pause', this.onPause);
      this.video.addEventListener('play', this.onPlay);
      this.motion.addEventListener('change', this.update);
      document.addEventListener('visibilitychange', this.update);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.update();
      }, {threshold: 0.15});
      this.observer.observe(this);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      if (!this.update) return;
      this.motion.removeEventListener('change', this.update);
      document.removeEventListener('visibilitychange', this.update);
      this.video.removeEventListener('pause', this.onPause);
      this.video.removeEventListener('play', this.onPlay);
      this.video.pause();
    }
  });
}
